module.exports = __webpack_public_path__ + "static/img/s205.1476129.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s205.png
// module id = 547
// module chunks = 3